import { render, staticRenderFns } from "./parcelDetails.vue?vue&type=template&id=ee19bb80&scoped=true&"
import script from "./parcelDetails.vue?vue&type=script&lang=js&"
export * from "./parcelDetails.vue?vue&type=script&lang=js&"
import style0 from "./parcelDetails.vue?vue&type=style&index=0&id=ee19bb80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee19bb80",
  null
  
)

export default component.exports